export default "__VITE_ASSET__D_DW44_n__"